import { useEffect, useState } from 'react'
import { Step5AlertDialog, Step5AlertDialogProps } from '../types'
import moment from 'moment'

export const useAlertDialog = (props: Step5AlertDialogProps): Step5AlertDialog => {
    const {
        form: { getValues },
        activationObject,
    } = props

    const startProtection = getValues('startProtection')
    const customerPresence = activationObject?.customerPresence
    const handoverKeysDateTime = activationObject?.handoverKeysDateTime
    const handoverDate = moment(handoverKeysDateTime).toDate()

    const [open, setOpen] = useState(false)
    const [isFirstRun, setIsFirstRun] = useState(true)

    useEffect(() => {
        if (customerPresence) {
            const isBefore = moment(handoverDate).isBefore(moment(startProtection))

            if (isBefore === false && isFirstRun) {
                setOpen(true)
            }

            if (isBefore === true) {
                setIsFirstRun(true)
                setOpen(false)
            }
        }
    }, [customerPresence, handoverDate, handoverKeysDateTime, isFirstRun, startProtection])

    return {
        open,
        handleClose: () => {
            setOpen(false)
            setIsFirstRun(false)
        },
    }
}
